import { Container } from 'aurelia-dependency-injection';
import {
	autoinject,
	bindable,
	bindingMode,
	customElement,
	inlineView,
} from 'aurelia-framework';
import React from 'react';

import ContextMenuList, {
	ContextMenuItem,
} from '~/components/context-menu-list/context-menu-list';
import { ReactComponent } from '~/components/react-component/react-component';

@autoinject
@customElement('context-menu-list-react')
@inlineView('<template ref="refContainer"></template>')
export class ContextMenuListReact extends ReactComponent {
	@bindable({
		defaultBindingMode: bindingMode.toView,
	})
	private readonly items: ContextMenuItem[] = [];

	/**
	 * updateDirOnChangeChanged is used to detect if a value
	 * has changed and whether to re-calculate the direction of the
	 * context menu (so it fits on screen)
	 *
	 * ie. render position for <context-menu> component or open/close state
	 * for <context-menu-button-react>
	 */
	@bindable({
		defaultBindingMode: bindingMode.toView,
	})
	private readonly updateDirOnChange?: any;

	@bindable({
		defaultBindingMode: bindingMode.toView,
	})
	private readonly onClose: () => void;

	/**
	 * Is the loader enabled for this menu?
	 */
	@bindable({ defaultBindingMode: bindingMode.toView })
	private isLoaderEnabled: boolean = false;

	/**
	 * Is the menu loading?
	 */
	@bindable({ defaultBindingMode: bindingMode.toView })
	private isLoading: boolean = false;

	/**
	 * The number of menu items to render in the loader
	 */
	@bindable({ defaultBindingMode: bindingMode.toView })
	private loaderItemCount: number;

	constructor(protected element: Element) {
		super('context-menu-list-react', element);
	}

	protected render() {
		this.renderReactDOM(
			<ContextMenuList
				items={this.items}
				isLoaderEnabled={this.isLoaderEnabled}
				loaderItemCount={this.loaderItemCount}
				isLoading={this.isLoading}
				updateDirOnChange={this.updateDirOnChange}
				onClose={this.onClose}
			/>,
		);
	}
}
